import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import LeaguesList from "./LeaguesList";

const Leagues = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Leagues" />
          <LeaguesList />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Leagues;
